import Entity from './entity'
import Producentarendetyp from './producentarendetyp'

export default class Kundhandelsetyp extends Entity  {
    namn: string
    steg: string
    producentarendetyp: Producentarendetyp
    producentarendetKraverKundatgard: boolean = false
    producentarendetKlart: boolean = false
    behorigheter: string
    beskrivning?: string
    rubrik?: string
    mojligaSprak: string


    constructor(producentarendetyp: Producentarendetyp, namn: string, steg: string, behorigheter: string, mojligaSprak: string = 'sv') {
        super()
        this.producentarendetyp = producentarendetyp
        this.namn = namn
        this.steg = steg
        this.behorigheter = behorigheter
        this.mojligaSprak = mojligaSprak
    }

    getIdentifierare = (): string => {
        return `${this.producentarendetyp.producent.aktor}.${this.producentarendetyp.identifierare}.${this.steg}`
    }
}